/** Pack-to-unit ratio derived from catalog values. Returns undefined when
 *  either side is missing or non-positive (custom items, missing data). */
export const deriveUnitsPerPack = (
  packPriceInMicros: number,
  perUnitPriceInMicros: number | null | undefined,
): number | undefined => {
  if (!perUnitPriceInMicros || packPriceInMicros <= 0) {
    return undefined;
  }
  return packPriceInMicros / perUnitPriceInMicros;
};
